module.exports = __webpack_public_path__ + "static/craftsrecords-8bae069cbfcf47f0972f8ce22dc3e4f0.png";